/**
 * ResearchInput Component
 * Input form for starting a new research session
 */

import React, { useState } from 'react';
import {
  View,
  TextInput,
  TouchableOpacity,
  Text,
  StyleSheet,
  ActivityIndicator,
} from 'react-native';
import { Colors } from '@/constants/colors';

interface ResearchInputProps {
  onSubmit: (topic: string) => void;
  isLoading: boolean;
}

export const ResearchInput: React.FC<ResearchInputProps> = ({ onSubmit, isLoading }) => {
  const [topic, setTopic] = useState('');

  const handleSubmit = () => {
    if (topic.trim() && !isLoading) {
      onSubmit(topic.trim());
    }
  };

  return (
    <View style={styles.container}>
      <Text style={styles.label}>Research Topic</Text>
      <TextInput
        style={styles.input}
        placeholder="e.g., AI agents in fintech, Electric vehicle market trends..."
        placeholderTextColor={Colors.text.tertiary}
        value={topic}
        onChangeText={setTopic}
        editable={!isLoading}
        multiline
        numberOfLines={3}
        textAlignVertical="top"
      />
      <TouchableOpacity
        style={[styles.button, (!topic.trim() || isLoading) && styles.buttonDisabled]}
        onPress={handleSubmit}
        disabled={!topic.trim() || isLoading}
      >
        {isLoading ? (
          <ActivityIndicator color={Colors.background.primary} size="small" />
        ) : (
          <Text style={styles.buttonText}>Start Research</Text>
        )}
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: 16,
    backgroundColor: Colors.background.secondary,
    borderRadius: 12,
    marginBottom: 16,
  },
  label: {
    fontSize: 14,
    fontWeight: '600',
    color: Colors.text.primary,
    marginBottom: 8,
  },
  input: {
    backgroundColor: Colors.background.primary,
    borderRadius: 8,
    padding: 12,
    fontSize: 15,
    color: Colors.text.primary,
    borderWidth: 1,
    borderColor: Colors.border.subtle,
    marginBottom: 12,
    minHeight: 80,
  },
  button: {
    backgroundColor: Colors.accent.primary,
    borderRadius: 8,
    padding: 14,
    alignItems: 'center',
  },
  buttonDisabled: {
    backgroundColor: Colors.text.tertiary,
    opacity: 0.5,
  },
  buttonText: {
    color: Colors.background.primary,
    fontSize: 16,
    fontWeight: '600',
  },
});
